import React, { Component } from "react";
import { InnerHeader, InnerItem } from "../Common/Slide/Inners";
import Slider from "../Helpers/Slider/Slider";
import EndSlide from "../Common/Slide/EndSlide";
import _Content from "../../static/data/content.json";
import { groupBy } from "../Services/Array";
import "./EndScreen.scss";
import { apiURL } from "../Services/baseURL";
import Loading from "../Services/Loading/Loading";
import { throwPopupEvent } from "../Services/Timing";
import { push } from "../Services/Analytics";
import { handleVote } from "../Services/Storage";

const __Categories__ = groupBy(_Content, g => g.Category);

export default class EndScreen extends Component {
    constructor(props) {
        super();
        this.renderCategories = this.renderCategories.bind(this);
        this.slideNavProxy = this.slideNavProxy.bind(this);
        this.sendForm = this.sendForm.bind(this);
        this.state = {
            Categories: [],
            Selected: {},
            isBusy: false,
            isLoading: false,
            OwlRef: {},
            render: "",
            firstInit: []
        }
    }
    componentDidMount() {
        this.renderCategories();
    }
    componentWillReceiveProps(newProps) {
        this.setState({
            Selected: newProps.Selected,
            OwlRef: newProps.OwlRef
        }, () => this.renderCategories());
    }
    renderCategories() {
        let Slides = [], index = 0;

        __Categories__.forEach(obj => {
            Slides.push(<InnerItem key={index} index={index}
                ChoiseSelected={this.state.Selected[index]}
                itemSelected={obj[this.state.Selected[index]]}
                isActive={this.state.Selected[index] != null}
                CategoryName={obj[0].Category}
                OwlRef={this.state.OwlRef}
                deleteCategory={this.props.deleteCategory}
                {...obj[this.state.Selected[index]]}
                _EndScreen
            />)
            index++;
        })
        this.setState({
            render: ""
        }, () => {
            window.setTimeout(() => {
                this.setState({
                    Categories: Slides,
                    render: <Slider
                        Selected={this.state.Selected}
                        responsive={{
                            0: {
                                items: 4,
                                slideBy: 4,
                                autoWidth: true,
                                rtl: true,
                                nav: false
                            },
                            1024: {
                                items: 5,
                                slideBy: 5,
                                center: false,
                                autoWidth: true,
                                rtl: true,
                                nav: true
                            }
                        }}>
                        {Slides}
                    </Slider>
                })
            }, 250);
        });
    }
    sendForm() {
        if (this.state.isBusy) return;
        if (handleVote.get("isVoted")) {
            throwPopupEvent({
                Type: "Message",
                ClassName: "thanks voted",
                Head: "אופס...",
                Desc: "לא ניתן להצביע יותר מפעם אחת",
                showInsta: true
            });
            return;
        }
        this.setState({
            isBusy: true
        })
        let _selected = [];
        const votes = this.state.Selected;
        const _length = Object.keys(_selected).length;
        Object.keys(votes).forEach(obj => _selected.push({ itemCategoryId: obj, itemValueId: votes[obj] }));

        if (Object.keys(votes).length < __Categories__.length) {
            alert("רגע, שכחת לבחור מועמד/ת מעוד קטגוריה!");
            this.setState({
                isBusy: false
            })
            if (Object.keys(votes).length > 0) {
                for (let i = 0; i < this.props.CategoryLength; i++) {
                    if(votes[i] != null) continue;
                    this.props.setNavBar(i, 0);
                    return;
                }
            }
            return;
        }
        this.setState({
            isLoading: true
        })

        fetch(`${apiURL}Save`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(_selected)
        }).then(data => data.json()).then(data => {
            this.setState({
                isBusy: false,
                isLoading: false
            });
            handleVote.set("isVoted", "true");
            push("Send Vote Clicked");
            throwPopupEvent({
                Type: "Message",
                ClassName: "thanks"
            });
        }).catch(e => console.log(e));
    }
    slideNavProxy(dir) {
        window.document.querySelector(`.slider-container .controller .arrow.${dir}`).click();
        window.setTimeout(() => {
            if (window.document.querySelector(`.slider-container .controller .arrow.${dir}`).className.indexOf("disabled") > -1) {
                this[dir == "right" ? "arrowRight" : "arrowLeft"].className += " disabled";
            } else {
                this[dir == "right" ? "arrowLeft" : "arrowRight"].className = this[dir == "right" ? "arrowLeft" : "arrowRight"].className.replace(" disabled", "");
            }
        }, 150);
    }
    render() {
        return (
            <section className="section section-end">
                <Loading initLoader={this.state.isLoading} />
                <InnerHeader name="הבחירות שלי" />
                <div className="padding">
                    <div className="container">
                        <div className="goal">
                            <div className="text">לשינוי הבחירה לחץ</div>
                            <div className="delete"></div>
                        </div>
                        <div className="slider-container">
                            <div ref={arrowRight => this.arrowRight = arrowRight} className="arrow right disabled" onClick={() => this.slideNavProxy("right")}></div>
                            <div className="slider">
                                {this.state.Categories.length > 0 ?
                                    this.state.render : ""}
                            </div>
                            <div ref={arrowLeft => this.arrowLeft = arrowLeft} className="arrow left" onClick={() => this.slideNavProxy("left")}></div>
                        </div>
                        <div className="button" onClick={this.sendForm}>
                            <div className="text">
                                בקיצור, סיימתי.
                            </div>
                        </div>
                        <div className="froga"></div>
                    </div>
                </div>
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/Screen/EndScreen.jsx